import { SafeAreaView, ScrollView, SxProp, View } from 'dripsy';
import React from 'react';

import { PageContainer } from '@/features/earn/components/page/PageContainer';
import { PageItem } from '@/features/earn/components/page/PageItem';
import { DevToolsPageHeader } from '../components/DevToolsPageHeader';
import { DevToolsStackRoutes, DevToolsStackScreenProps } from '../types';
import { TextBody, TextTitle } from '@/design-system/components/typography';
import { Icon, SVGIconListArray } from '@/design-system/components/icons/Icon';
import { UniInput } from '@/design-system/components/inputs';
import { keyGenerator } from '@/utils/keyGenerator';

export const DevToolsIcons: React.FC<DevToolsStackScreenProps<DevToolsStackRoutes.Icons>> = (props) => {
  const iconList = SVGIconListArray;
  const [searchText, setSearchText] = React.useState('');

  return (
    <SafeAreaView sx={styles.container}>
      <ScrollView showsVerticalScrollIndicator={false}>
        <PageContainer sx={{ paddingX: '$10', paddingY: '$10', backgroundColor: 'transparent' }}>
          <DevToolsPageHeader currentPage={DevToolsStackRoutes.Icons} />
          {/* <Divider /> */}
          <PageItem sx={{ ...styles.pageItem, gap: '$7' }}>
            <PageItem sx={{ ...styles.pageItem }}>
              <TextTitle bold>Importing Icons</TextTitle>
              <TextBody>1. Download the icon you want from design file, the icon must be in SVG format.</TextBody>
              <TextBody>2. Unzip and move .svg files to~/./assets/svg.</TextBody>
              <TextBody>
                3. Run `npm run generateSvgIconIndex` to generate an index file `index.tsx`, which contains all converted svg files.
              </TextBody>
            </PageItem>
            <PageItem sx={{ ...styles.pageItem }}>
              <TextTitle bold>Usage</TextTitle>
              <TextBody sx={{ fontFamily: 'monospace ' }}>import {Icon} from '@/design-system/components/icons/Icon';</TextBody>
              <TextBody sx={{ fontFamily: 'monospace ' }}>{`<Icon name="iconName" height={100} width={100} />`}</TextBody>
            </PageItem>
            <View sx={{ gap: '5' }}>
              <UniInput
                labelText="Search Icon"
                placeholder="Search Icon"
                onValueChange={(value) => setSearchText(value || '')}
                sx={{ mb: '$5' }}
              />
              <View sx={{ flexDirection: 'row', flexWrap: 'wrap', gap: '$2' }}>
                {iconList
                  .filter((icon) => icon.toLowerCase().includes(searchText.toLowerCase()))
                  .map((icon) => (
                    <PageItem
                      key={keyGenerator('colors')}
                      sx={{
                        ...styles.pageItem,
                        flexGrow: 1,
                        width: 200,
                        height: 200,
                        gap: '$2',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}>
                      <TextBody semiBold>{icon}</TextBody>
                      <Icon name={icon} height={100} width={100} />
                    </PageItem>
                  ))}
              </View>
            </View>
          </PageItem>
        </PageContainer>
      </ScrollView>
    </SafeAreaView>
  );
};

enum StyleName {
  container = 'container',
  pageItem = 'pageItem'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    height: '100%',
    width: '100%',
    backgroundColor: '$backgroundPrimary'
  },
  pageItem: {
    width: '100%',
    padding: '$7',
    borderRadius: 10,
    gap: '$2'
  }
};
